import { api } from './client'
import type {
  DismissReason,
  DismissedRecommendationsResponse,
  RecommendationsResponse,
} from '@/types'

export function fetchRecommendations(groupId: string): Promise<RecommendationsResponse> {
  return api.get<RecommendationsResponse>(`/groups/${groupId}/recommendations`)
}

export function refreshRecommendations(groupId: string): Promise<{ status: string }> {
  return api.post<{ status: string }>(`/groups/${groupId}/recommendations/refresh`, {})
}

export function dismissRecommendation(
  groupId: string,
  appId: string,
  reason: DismissReason | null = null,
): Promise<void> {
  return api.post<void>(`/groups/${groupId}/recommendations/${appId}/dismiss`, { reason })
}

export function setDismissReason(
  groupId: string,
  appId: string,
  reason: DismissReason | null,
): Promise<void> {
  return api.patch<void>(`/groups/${groupId}/recommendations/${appId}/dismiss`, { reason })
}

export function undismissRecommendation(groupId: string, appId: string): Promise<void> {
  return api.delete<void>(`/groups/${groupId}/recommendations/${appId}/dismiss`)
}

export function fetchDismissedRecommendations(
  groupId: string,
): Promise<DismissedRecommendationsResponse> {
  return api.get<DismissedRecommendationsResponse>(
    `/groups/${groupId}/recommendations/dismissed`,
  )
}

export function topupRecommendations(groupId: string): Promise<{ status: string }> {
  return api.post<{ status: string }>(`/groups/${groupId}/recommendations/topup`, {})
}
